import React, { useState, useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import { Toast as NotificationToast } from '../../tools/Toast'
import { getRoleSupervisors, createBatchSupervisors } from '../../../../redux/actions'

import Swal from 'sweetalert2'

import { v4 as uuidv4 } from 'uuid'

import {
  Grid, Paper, Button, Typography, IconButton,
  FormControl, InputLabel, Select, Input, MenuItem, Chip,
  Table, TablePagination, TableBody, TableCell, TableRow, TableHead, TableContainer,
  Dialog, DialogTitle, DialogContent, Checkbox
} from '@material-ui/core'

import AddCircleIcon from '@material-ui/icons/AddCircle'
import CloseIcon from '@material-ui/icons/Close'

import TreeView from '@material-ui/lab/TreeView'

import UnitTree from '../../tools/UnitTree'
import { keyify2, handleTextPrepper, handlePhonePrepper } from '../../../../utils'

import UserMgmtCreate from './UserMgmtCreate'

import { makeStyles } from '@material-ui/core/styles'
import { withStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  batchUserPagination: {
    // marginLeft: 'auto',
    // marginRight: 'auto'
  },
  userPaper: {
    width: '100%',
    height: '100%'
  },
  container: {
    maxHeight: '33em'
  },
  importBtn: {
    color: '#ffffff',
    backgroundColor: '#3984f7',
    marginLeft: 'auto',
    marginRight: 'auto',
    '&:hover': {
      color: '#ffffff',
      backgroundColor: '#0651C4'
    }
  },
  formControl: {},
  singleChip: {
    width: '85%'
  },
  cssUnderline: {
    marginBottom: 'auto',
    marginTop: 'auto',
    '&:after': {
      borderBottomColor: '#A4D164'
    }
  },
  cssLabel: {
    width: '100%',
    '&$cssFocused': {
      color: '#A4D164',
      width: '100%'
    }
  },
  cssFocused: {
  },
  roleItem: {
    fontWeight: theme.typography.fontWeightMedium
  },
  allUnitsBtn: {
    color: '#fff',
    backgroundColor: '#A4D164',
    '&:hover': {
      backgroundColor: '#8AB651'
    },
    '&:disabled': {
      backgroundColor: theme.palette.action.disabledBackground
    }
  },
  unitApplyBtn: {
    backgroundColor: '#3984f7',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0651C4'
    },
    marginTop: theme.spacing(2)
  }
}))

const GreenCheckbox = withStyles({
  root: {
    color: '#595959',
    '&$checked': {
      color: '#A4D164'
    }
  },
  checked: {}
})((props) => <Checkbox color='default' {...props} />)

const batchErrors = {
  EMAIL_ERROR: 'email-error',
  ENTRY_ERROR: 'entry-error',
  ROLE_ERROR: 'role-error',
  UNIT_ERROR: 'unit-error'
}

const UserMgmtBatchCreate = (props) => {
  const { onBackBatchUsers, usersInfo, roles, onSuccess, batchUsers } = props
  // const { onBackToList } = props

  const classes = useStyles()
  const dispatch = useDispatch()

  const headers = ['First Name', 'Last Name', 'Job Title', 'Office Phone', 'Email Address', 'Roles', 'Units']

  const unitTree = useSelector(state => state.auth.unitTree)

  const [users, setUsers] = useState([])
  const [userRoles, setUserRoles] = useState([])

  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(20)

  const [adminRole, setAdminRole] = useState('')
  const [adminRoleName, setAdminRoleName] = useState('')
  const [adminUnits, setAdminUnits] = useState([])
  const [expandedKeys, setExpandedKeys] = useState([])

  const [openUnits, setOpenUnits] = useState(false)
  const [sendOnboardingEmail, setSendOnboardingEmail] = useState(true)

  const [editInfo, setEditInfo] = useState({
    userID: '',
    firstName: '',
    lastName: '',
    jobTitle: '',
    emailAddress: '',
    officePhone: '',
    roleID: '',
    roleName: '',
    units: [],
    enableEditing: false,
    error: true,
    errorType: ''
  })

  useEffect(() => {
    if (batchUsers && usersInfo && Array.isArray(usersInfo) && Boolean(batchUsers.length)) {
      const mappedInfo = batchUsers.map((userInfo) => {
        const { firstName, lastName, jobTitle, officePhone, emailAddress } = userInfo
        const userID = `US${uuidv4().replace(/-/g, '')}`

        const emailExists = usersInfo.findIndex((existingUser) => existingUser.emailAddress === emailAddress) !== -1

        return ({
          userID,
          firstName,
          lastName,
          jobTitle,
          officePhone,
          emailAddress,
          roleID: '',
          roleName: '',
          units: [],
          enableEditing: false,
          error: true,
          errorType: emailExists ? batchErrors.EMAIL_ERROR : batchErrors.ENTRY_ERROR
        })
      })

      setUsers([...mappedInfo])
    }
  }, [batchUsers, usersInfo])

  useEffect(() => {
    if (roles) {
      setUserRoles([{ roleID: '', roleName: 'None' }, ...roles])
    }
  }, [roles])

  const handleUserInfoChange = (infoKey, infoVal) => {
    setEditInfo({ ...editInfo, [infoKey]: infoVal })
  }

  const handleEditUser = (userInfo) => {
    if (users && Array.isArray(users)) {
      const tempUsers = [...users]
      const userIndex = tempUsers.findIndex((allUserInfo) => allUserInfo.userID === userInfo.userID)

      if (userIndex !== -1) {
        const editIndex = tempUsers.findIndex((tempInfo) => tempInfo.enableEditing === true)
        if (editIndex !== -1) { tempUsers[editIndex] = { ...editInfo, enableEditing: false } }

        const targetUser = tempUsers[userIndex]
        tempUsers[userIndex] = { ...targetUser, enableEditing: true }
        setEditInfo({ ...userInfo, enableEditing: true })
        setUsers([...tempUsers])
      }
    }
  }

  const handleOnboardingEmailChange = (e) => {
    setSendOnboardingEmail(!sendOnboardingEmail)
  }

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10))
    setPage(0)
  }

  const handleDeleteUser = (userID) => {
    const tempUsers = [...users]
    const newUsers = tempUsers.filter((userInfo) => userInfo.userID !== userID)
    setUsers([...newUsers])
  }

  const handleAddRow = () => {
    const tempUsers = [...users]
    const userID = `US${uuidv4().replace(/-/g, '')}`
    const userInfo = {
      userID,
      firstName: '',
      lastName: '',
      jobTitle: '',
      officePhone: '',
      emailAddress: '',
      roleID: '',
      roleName: '',
      units: [],
      enableEditing: true,
      error: true,
      errorType: batchErrors.ENTRY_ERROR
    }

    const editIndex = tempUsers.findIndex((tempInfo) => tempInfo.enableEditing === true)
    if (editIndex !== -1) { tempUsers[editIndex] = { ...editInfo, enableEditing: false } }

    tempUsers.push({ ...userInfo })
    setEditInfo({ ...userInfo })
    setUsers([...tempUsers])
  }

  const handleImport = async () => {
    if (users.length) {
      let roleError = false
      let roleCount = 0
      let editingError = false
      let editingCount = 0

      const list = []
      const newUsers = []

      users.forEach((userInfo) => {
        if (userInfo.roleID === '') {
          roleError = true
          roleCount += 1
          list.push(` ${userInfo.firstName} ${userInfo.lastName}`)
        }

        if (userInfo.enableEditing) {
          editingError = true
          editingCount += 1
        }

        if (!userInfo.error && !userInfo.enableEditing) {
          newUsers.push({
            firstName: handleTextPrepper(userInfo.firstName),
            lastName: handleTextPrepper(userInfo.lastName),
            jobTitle: handleTextPrepper(userInfo.jobTitle),
            officePhone: userInfo.officePhone !== '' ? handlePhonePrepper(userInfo.officePhone) : '',
            emailAddress: handleTextPrepper(userInfo.emailAddress),
            roleID: userInfo.roleID,
            units: userInfo.units.sort().filter((unitID) => unitID !== unitTree[0].key)
          })
        }
      })

      if (roleError) {
        const roleVal = roleCount === 1 ? `${roleCount} user has` : `${roleCount} users have`
        await Swal.fire({
          icon: 'warning',
          title: `${roleVal} not been assigned a role!`,
          html: `
          <h4>Users not assigned roles:</h4>
          <p>${list}</p>
          `
        })
      } else if (editingError) {
        const editVal = editingCount === 1 ? `${editingCount} user` : `${editingCount} users`
        await Swal.fire({
          icon: 'warning',
          title: `${editVal} are in edit mode!`,
          text: 'Please either delete the users or exit edit mode.'
        })
      } else {
        if (newUsers.length) {
          dispatch(createBatchSupervisors(newUsers, sendOnboardingEmail, fireSuccess, fireFailure))
        } else {
          NotificationToast(false, 'Must have at least one valid user!', true)
        }
      }
    } else {
      NotificationToast(false, 'Must create at least one user!', true)
    }
  }

  const fireSuccess = async () => {
    dispatch(getRoleSupervisors())
    NotificationToast(false, 'Successfully created batch users!')
    onSuccess()
  }

  const fireFailure = async () => {
    NotificationToast(true, 'Failed to create batch users!')
  }

  const handleAllRoleChange = (roleID) => {
    if (roleID && userRoles && Array.isArray(userRoles)) {
      const roleInfo = userRoles.find((userRole) => userRole.roleID === roleID)

      if (roleInfo && roleInfo.roleID) {
        setAdminRole(roleID)
        setAdminRoleName(roleInfo.roleName)

        const tempUsers = [...users]
        const newUsers = tempUsers.map((userInfo) => {
          if (userInfo.errorType) {
            if (roleID !== '' && userInfo.units.length && userInfo.firstName !== '' && userInfo.lastName !== '') {
              return { ...userInfo, roleID, roleName: roleInfo.roleName, error: false, errorType: '' }
            }
          }

          return { ...userInfo, roleID, roleName: roleInfo.roleName }
        })

        setUsers([...newUsers])
      } else {
        setAdminRole('')
        setAdminRoleName('')
      }
    } else {
      // should not happen
      NotificationToast('Failed to set roles for users!')
    }
  }

  const manageUnits = () => {
    setOpenUnits(true)

    const unitKeys = keyify2(unitTree)
    setExpandedKeys(unitKeys)
  }

  const handleUnitClick = (ancestors, key, isSelected, children) => {
    if (!isSelected) {
      const unitsToAdd = []
      let selection = []

      if (!ancestors.length) {
        selection = [key, ...keyify2(children)]
      } else {
        selection = [...ancestors, key, ...keyify2(children)]
      }

      selection.forEach((selectedKey) => {
        if (adminUnits.findIndex((assignedUnit) => assignedUnit === selectedKey) === -1) {
          unitsToAdd.push(selectedKey)
        }
      })

      setAdminUnits([...adminUnits, ...unitsToAdd])
    } else {
      if (ancestors.length) {
        const tempAssigned = [...adminUnits].filter((assignedUnit) => assignedUnit !== key)
          .filter((assignedUnit) => children.findIndex((childUnit) => childUnit.key === assignedUnit) === -1)

        setAdminUnits(tempAssigned)
      } else {
        setAdminUnits([])
      }
    }
  }

  const handleUnitApply = () => {
    const tempUsers = [...users]
    const newUsers = tempUsers.map((userInfo) => {
      if (userInfo.errorType) {
        if (adminUnits.length && userInfo.roleID !== '' && userInfo.firstName !== '' && userInfo.lastName !== '') {
          return { ...userInfo, units: adminUnits, error: false, errorType: '' }
        }
      }

      return { ...userInfo, units: adminUnits }
    })

    setUsers([...newUsers])
    setOpenUnits(false)
  }

  const handleConfigChange = (configInfo = {}) => {
    if (configInfo && configInfo.userID) {
      const tempUsers = [...users]
      const userIndex = tempUsers.findIndex((userInfo) => userInfo.userID === configInfo.userID)

      if (userIndex !== -1) {
        let configRoleName = ''

        const emailError = !configInfo || configInfo.emailAddress === ''
          ? true : usersInfo.findIndex((user) => user.emailAddress === configInfo.emailAddress) !== -1

        const entryError = !configInfo || configInfo.firstName === '' || configInfo.lastName === ''

        const unitError = !configInfo || !configInfo.units || !configInfo.units.length

        const roleError = !configInfo || !configInfo.roleID || configInfo.roleID === ''

        if (userRoles && Array.isArray(userRoles) && configInfo.roleID) {
          const configRole = userRoles.find((roleInfo) => roleInfo.roleID === configInfo.roleID)
          if (configRole) { configRoleName = configRole.roleName }
        }

        const hasConfigError = entryError || emailError || roleError || unitError
        const hasConfigErrorType = emailError
          ? batchErrors.EMAIL_ERROR : entryError
            ? batchErrors.ENTRY_ERROR : roleError
              ? batchErrors.ROLE_ERROR : unitError
                ? batchErrors.UNIT_ERROR : ''

        const formatConfigInfo = {
          ...configInfo,
          roleName: !configRoleName ? configInfo.roleName : configRoleName,
          error: hasConfigError,
          errorType: hasConfigErrorType
        }

        tempUsers[userIndex] = formatConfigInfo
        setEditInfo({
          ...editInfo,
          roleName: !configRoleName ? configInfo.roleName : configRoleName,
          roleID: configInfo.roleID,
          enableEditing: configInfo.enableEditing,
          units: configInfo.units,
          error: hasConfigError,
          errorType: hasConfigErrorType
        })
        setUsers([...tempUsers])
      }
    }
  }

  return (
    <>
      <Grid container direction='row'>
        <Grid container item direction='column' spacing={2} className='mx-auto w-100'>
          <Grid container item direction='row' className='mx-auto'>
            <button type='button' className='btn green-button' onClick={onBackBatchUsers}>Back</button>
            {/* <button type='button' className='btn blue-button ml-auto' onClick={onBackToList}>Back To List</button> */}
          </Grid>

          <Grid container item direction='row'>
            <h2 className='mt-3 mb-2'>Batch Users</h2>
          </Grid>

          <Grid container item direction='row' justify='center'>
            <Grid container item direction='row' xs={8} justify='flex-end'>
              <TablePagination
                component='div'
                count={users.length}
                page={page}
                onChangePage={(e, newPage) => setPage(newPage)}
                rowsPerPage={rowsPerPage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                className={classes.batchUserPagination}
                rowsPerPageOptions={[10, 20, 30, 50, 100]}
              />
            </Grid>
            <Grid container item direction='row' xs={4} spacing={2} className='mx-auto'>
              <Grid item xs={6} className='py-0'>
                <FormControl fullWidth className={classes.formControl} disabled={!users.length}>
                  <InputLabel id='multiple-roles-label' classes={{ root: classes.cssLabel, focused: classes.cssFocused }}>Select All Roles</InputLabel>
                  <Select
                    labelId='multiple-roles-label'
                    id='multiple-roles'
                    value={adminRole}
                    className={classes.cssUnderline}
                    input={<Input id='select-multiple-roles' />}
                    onChange={(e) => handleAllRoleChange(e.target.value)}
                    renderValue={() => {
                      return (
                        <div>
                          <Chip label={adminRoleName} className={classes.singleChip} />
                        </div>
                      )
                    }}
                  >
                    {userRoles.map((role, i) => (
                      <MenuItem key={i} value={role.roleID} className={classes.roleItem}>
                        {role.roleName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={6} className='py-0'>
                <Button
                  variants='contained'
                  onClick={manageUnits}
                  className={classes.allUnitsBtn}
                  disabled={!users.length}
                >
                  Select All Units
                </Button>
              </Grid>
            </Grid>
          </Grid>

          <Grid container item direction='row' className='mx-auto px-0'>
            <Paper elevation={2} className={classes.userPaper}>
              <TableContainer className={classes.container}>
                <Table stickyHeader aria-label='sticky-table'>
                  <TableHead>
                    <TableRow>
                      <TableCell />
                      {headers.map((info, index) => {
                        return (
                          <TableCell key={`${info}-${index}`} align='center'>
                            {info}
                          </TableCell>
                        )
                      })}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                      users.length !== 0
                        ? users.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((info, index) => {
                          return (
                            <UserMgmtCreate
                              key={`user-create-${info.userID}`}
                              userInfo={info}
                              editInfo={editInfo}
                              existingUsers={usersInfo}
                              onUserInfoChange={handleUserInfoChange}
                              onEditUser={handleEditUser}
                              onDeleteUser={handleDeleteUser}
                              onConfigChange={handleConfigChange}
                            />
                          )
                        }) : <></>
                    }
                  </TableBody>
                </Table>
              </TableContainer>

              <Grid container item direction='row' className='mx-auto w-100 my-2'>
                <Button className={`${classes.importBtn}`} variant='contained' size='large' onClick={handleAddRow}>
                  <AddCircleIcon />
                </Button>
              </Grid>
            </Paper>
          </Grid>

          <Grid item container direction='row' className='mx-auto w-100 my-2'>
            <Grid item xs={10}>
              <Typography variant='subtitle2' className='text-muted' style={{ textTransform: 'none', marginTop: '.7rem' }}>
                Would you like to like to send an onboarding email to the new users?
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <GreenCheckbox
                className='ml-3'
                value='severity'
                onChange={handleOnboardingEmailChange}
                checked={Boolean(sendOnboardingEmail)}
              />
            </Grid>
          </Grid>

          <Grid container item direction='row' className='mt-3 mx-auto w-100'>
            <Button className={classes.importBtn} variant='contained' onClick={handleImport}>Import</Button>
          </Grid>
        </Grid>
      </Grid>

      <Dialog open={openUnits} scroll='paper' disableBackdropClick disableEscapeKeyDown>
        <DialogTitle disableTypography>
          <Grid container direction='row' className='mx-auto w-100' justify='space-between' alignItems='center'>
            <Grid item>
              <Typography variant='h6' className={`${classes.roleTitle}`}>Select Units</Typography>
            </Grid>
            <Grid item>
              <IconButton className={classes.closeButton} onClick={() => setOpenUnits(false)}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent className='pl-1'>
          <Grid container direction='row'>
            <Grid container item direction='column'>

              <Grid container item direction='row' justify='center'>
                <TreeView disableSelection expanded={expandedKeys}>
                  <UnitTree
                    treeData={unitTree}
                    onUnitClick={handleUnitClick}
                    selectedKeys={adminUnits}
                    isCheckbox
                  />
                </TreeView>
              </Grid>

              <Grid container item direction='row' justify='center' className='ml-2'>
                <Button
                  variant='contained'
                  onClick={handleUnitApply}
                  className={classes.unitApplyBtn}
                >
                  Apply
                </Button>
              </Grid>

            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default UserMgmtBatchCreate
